export default "__VITE_ASSET__DOKeTJHC__"